module.exports = __webpack_public_path__ + "img/icon_newsletter.06d05eb1.png";